import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Graceful fallback: if REACT_APP_API_URL is not set, default to same-origin requests.
// This prevents axios from attempting to hit an "undefined/api" host in development.
const resolvedBaseURL = API_URL && API_URL.trim() !== ''
  ? `${API_URL.replace(/\/$/, '')}/api`  // ensure exactly one slash between host and '/api'
  : '/api';

/**
 * Configured axios instance for API requests
 */
const api = axios.create({
  baseURL: resolvedBaseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to inject auth token when available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      // Check if not on auth pages
      if (!window.location.pathname.includes('/login') && 
          !window.location.pathname.includes('/signup') && 
          !window.location.pathname.includes('/forgot-password')) {
        // Clear any stored credentials
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Redirect to login page
        window.location.href = '/login?sessionExpired=true';
      }
    }
    return Promise.reject(error);
  }
);

export default api; 